import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Hungary() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Hungary') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [provider, setProvider] = useState();
    const [legalAddress, setLegalAddress] = useState();
    const [vatNum, setVatNum] = useState();
    const [companyRegNum, setCompanyRegNum] = useState();

    const [subscriber, setSubscriber] = useState();
    const [legalAddCust, setLegalAddCust] = useState();
    const [subscriberCode, setSubscriberCode] = useState();
    const [transProvider, setTransProvider] = useState();
    const [date, setDate] = useState();
    const [portingDate, setPortingDate] = useState();
    const [signature, setSignature] = useState();

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#provider').value = form?.country?.donor?.provider ?? '';
        document.querySelector('#legalAddress').value = form?.country?.donor?.legalAddress ?? '';
        document.querySelector('#vatNum').value = form?.country?.donor?.vatNum ?? '';
        document.querySelector('#companyRegNum').value = form?.country?.donor?.companyRegNum ?? '';
        setProvider(form?.country?.donor?.provider ?? '');
        setLegalAddress(form?.country?.donor?.legalAddress ?? '');
        setVatNum(form?.country?.donor?.vatNum ?? '');
        setCompanyRegNum(form?.country?.donor?.companyRegNum ?? '');

        document.querySelector('#subscriber').value = form?.country?.customer?.subscriber ?? '';
        document.querySelector('#legalAddCust').value = form?.country?.customer?.legalAddCust ?? '';
        document.querySelector('#subscriberCode').value = form?.country?.customer?.subscriberCode ?? '';
        document.querySelector('#transProvider').value = form?.country?.customer?.transProvider ?? '';
        document.querySelector('#date').value = form?.country?.customer?.date ?? '';
        document.querySelector('#portingDate').value = form?.country?.customer?.portingDate ?? '';
        document.querySelector('#signature').value = form?.country?.customer?.signature ?? '';
        setSubscriber(form?.country?.customer?.subscriber ?? '');
        setLegalAddCust(form?.country?.customer?.legalAddCust ?? '');
        setSubscriberCode(form?.country?.customer?.subscriberCode ?? '');
        setTransProvider(form?.country?.customer?.transProvider ?? '');
        setTableDataRange(form?.country?.customer?.tableDataRange ?? []);
        setSignature(form?.country?.customer?.signature ?? '');
        setDate(form?.country?.customer?.date ?? '');
        setPortingDate(form?.country?.customer?.portingDate ?? '');
    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^[^a-zA-Z]+$/.test(row.sNumber);
                const isEndValid = /^[^a-zA-Z]+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Hungary",
            "donor": {
                "provider": provider,
                "legalAddress": legalAddress,
                "vatNum": vatNum,
                "companyRegNum": companyRegNum
            },
            "customer": {
                "subscriber": subscriber,
                "legalAddCust": legalAddCust,
                "subscriberCode": subscriberCode,
                "transProvider": transProvider,
                "tableDataRange": tableDataRange,
                "date": date,
                "portingDate": portingDate,
                "signature": signature
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!subscriber) {
            validationErrors.subscriber = 'Please fill in Subscriber';
        }
        if (!legalAddCust) {
            validationErrors.legalAddCust = 'Please fill in Legal address';
        }
        if (!subscriberCode) {
            validationErrors.subscriberCode = 'Please fill in Subscriber code/client identifier';
        }
        if (!transProvider) {
            validationErrors.transProvider = 'Please fill in Transferring Provider';
        }
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^[^a-zA-Z]+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^[^a-zA-Z]+$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        if (!date) {
            validationErrors.date = 'Please fill in Date';
        }
        if (!portingDate) {
            validationErrors.portingDate = 'Please fill in Requested Porting Date';
        }
        if (!signature) {
            validationErrors.signature = 'Please fill in Signature';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = provider + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home'
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <p>Előfizetői Nyilatkozat / Subscriber’s Declaration
                        (Számhordozás igénybevételéhez / -for using the Number Porting Service) </p> <br></br>

                    <h2 className='heading'>Donor details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('provider')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Szolgáltató</label> <br />
                            <input
                                onChange={(e) => setProvider(e.target.value)}
                                type="text"
                                id="provider"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'provider' && (
                                <div className="hover-description">
                                    Provider (e.g. UnicoTel Távközlési Kft)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('legalAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Székhely</label> <br />
                            <input
                                onChange={(e) => setLegalAddress(e.target.value)}
                                type="text"
                                id="legalAddress"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'legalAddress' && (
                                <div className="hover-description">
                                    Legal Address (e.g. 1112 Budapest, Üröm u. 8.)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('vatNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Adószám</label> <br />
                            <input
                                onChange={(e) => setVatNum(e.target.value)}
                                type="text"
                                id="vatNum"
                                placeholder=""
                                className={`inputbox ${validationStates.vatNum === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^(?=(?:\D*\d){11}\D*$)[\d-]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, vatNum: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only 11 digits numeric values are allowed.'
                                        );
                                    }
                                }}
                            />
                            {hoveredField === 'vatNum' && (
                                <div className="hover-description">
                                    VAT Number (e.g. 32455351-2-43)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col xs={4}
                            onMouseEnter={() => handleMouseEnter('companyRegNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Cégje yzékszám</label> <br />
                            <input
                                onChange={(e) => setCompanyRegNum(e.target.value)}
                                type="text"
                                id="companyRegNum"
                                placeholder=""
                                className={`inputbox ${validationStates.companyRegNum === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    const isValid = value === '' || /^(?=(?:\D*\d){10}\D*$)[\d-]+$/u.test(value);
                                    setValidationStates(prev => ({ ...prev, companyRegNum: isValid }));

                                    if (value !== '' && !isValid) {
                                        toast.error(
                                            'Only 10 digits numeric values are allowed.'
                                        );
                                    }
                                }}
                            />
                            {hoveredField === 'companyRegNum' && (
                                <div className="hover-description">
                                    Company Registration Number (e.g. 01-09-424972)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Details</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('subscriber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Előfizető*</label> <br />
                            <input
                                onChange={(e) => setSubscriber(e.target.value)}
                                type="text"
                                id="subscriber"
                                placeholder=""
                                className={`inputbox ${validationStates.subscriber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('subscriber', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'subscriber' && (
                                <div className="hover-description">
                                    Subscriber
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('legalAddCust')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Székhely*</label> <br />
                            <input
                                onChange={(e) => setLegalAddCust(e.target.value)}
                                type="text"
                                id="legalAddCust"
                                placeholder=""
                                className={`inputbox ${validationStates.legalAddCust === false ? 'error' : ''}`}
                                onBlur={() => validateInput('legalAddCust', /^[a-zA-Z0-9\s\W]+$/)}

                            />
                            {hoveredField === 'legalAddCust' && (
                                <div className="hover-description">
                                    Legal Address
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('subscriberCode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Egyéb*</label> <br />
                            <input
                                onChange={(e) => setSubscriberCode(e.target.value)}
                                type="text"
                                id="subscriberCode"
                                placeholder=""
                                className={`inputbox ${validationStates.subscriberCode === false ? 'error' : ''}`}
                                onBlur={() => validateInput('subscriberCode', /^(?=(?:\D*\d){9}\D*$)[\d-]+$/)}

                            />
                            {hoveredField === 'subscriberCode' && (
                                <div className="hover-description">
                                    Subscriber code/client identifier (e.g. 860487969)
                                </div>
                            )}
                        </Col>

                        <Row></Row>

                        <br></br>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('transProvider')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Átadó Szolgáltató*</label> <br />
                                <input
                                    onChange={(e) => setTransProvider(e.target.value)}
                                    type="text"
                                    id="transProvider"
                                    placeholder=""
                                    className={`inputbox ${validationStates.transProvider === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('transProvider', /^.*$/)}

                                />
                                {hoveredField === 'transProvider' && (
                                    <div className="hover-description">
                                        Transferring Provider
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Az Előfizető által megtartani kívánt telefonszám(ok) / Numbers that the subscriber wishes to keep</h2> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>

                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start*</th>
                                <th>Number range end*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Range */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^[^a-zA-Z]+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[^a-zA-Z]+$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Number Range Start
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^[^a-zA-Z]+$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^[^a-zA-Z]+$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Number Range End
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Kelt*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => { validateInput('date', /^.*$/); }}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Date
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('portingDate')}
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>Hordozás kértn apja*</label> <br />
                            <input
                                onChange={(e) => setPortingDate(e.target.value)}
                                type="date"
                                id="portingDate"
                                value={portingDate}
                                className={`inputbox ${validationStates.portingDate === false ? 'error' : ''}`}
                                onBlur={() => { validateInput('portingDate', /^.*$/); }}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                            {hoveredField === 'portingDate' && (
                                <div className="hover-description">
                                    Date of requested porting
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>Aláírás*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Signature
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Hungary;